module.exports = __webpack_public_path__ + "static/media/Allison Hong.d9bdbb3f.png";